// extracted by mini-css-extract-plugin
module.exports = {"textbox-container":"styles_textbox-container__3z0Xy","textbox":"styles_textbox__MmCik","error":"styles_error__38pZg","error-message":"styles_error-message__1skv-"};